import { useTranslation } from 'react-i18next';
import { homepageUrl } from '../Core/Config';
import homeIcon from '../Images/home.svg';

export default function BackToHomepage() {
    const { t } = useTranslation('selection');

    return (
        <a className="back-to-homepage" href={homepageUrl}>
            <img src={homeIcon} width="26" height="26" alt="" />
            <span>{t('back-to-homepage')}</span>
        </a>
    );
}
